import React from 'react';
import {Button, ButtonGroup, Card, CardBody, CardHeader, Col, Modal, ModalBody, Row, Table,} from 'reactstrap';
import {parseDate} from '../../utils/Utilities';
import Global, {DD_MM_YYYY_HH_MM_SS, INSPECTION_STATUS_COLOR} from '../../utils/Global';
import queryString from 'query-string';
// import label from '../../message/Label'
import label from 'enqc-utilities/src/label/Label'

import PropTypes from "prop-types";
import BaseComponent from "../BaseComponent";
import ModalPagination from "../ModalPagination";
import {inspectionEventsFromNative} from "../../utils/MyUtilities";
import DropdownInput from "../form/DropdownInput";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import ModalCardHeader from "../Widget/ModalCardHeader";
import StatusWidget from "../Widget/StatusWidget";
import UserButton from "../Widget/UserButton";


export default class InspectionEventHistoryModal extends BaseComponent{

    constructor(props) {
        super(props);
        this.state ={
            ascending:false,
            inspection:this.props.inspection,
            sortir:'jie.updated',
            page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
            key:queryString.parse(this.props.query).tab?queryString.parse(this.props.query).tab:label.All,
            totalPage:0,
            totalElement:0,
            pageElement:0,
            createdStartDate:null,
            createdEndDate:null,
            inspectionEvents:[],
            inspectionStatus:null,
            inspectionStatusId:null,
            search:queryString.parse(this.props.query).search?queryString.parse(this.props.query).search:"",
            inputSearch : "",
        }
    }


    componentWillReceiveProps(props, nextContext) {
        if(props!=this.props && props.showing && props.inspection && props.inspection.id){
            let page = queryString.parse(props.query).page?queryString.parse(props.query).page:1
            let key = queryString.parse(props.query).tab?queryString.parse(props.query).tab:label.All
            let search = queryString.parse(props.query).search?queryString.parse(props.query).search:""
            let inspectionStatusId = null
            if(key===label.All){
                inspectionStatusId = null
            }else{
                inspectionStatusId = key
            }
            this.setState({
                page:page,
                key:key,
                search:search,
                inspectionStatusId:inspectionStatusId,
                inspection:props.inspection,
            }, () => {
                this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, true)
            })
        }
    }

    fetchAll = (ascending, sortir, search, progressing, excelMode) =>{
        let params = {
            inspectionStatusId:this.state.inspectionStatusId,
            ascending:ascending,
            sortir:sortir,
            search:search,
            page:this.state.page-1,
            reference:this.state.inspection.reference,
            createdStartDate:this.state.createdStartDate,
            createdEndDate:this.state.createdEndDate,
            excelMode:excelMode

        }
        if(excelMode){
            this.asyncDownloadGet(Global.API.INSPECTION_EVENTS, {params:params}, null,true);
            return
        }
        this.get(Global.API.INSPECTION_EVENTS, {params:params}, null, res =>{
            if(res.code === 200){
                let inspectionEvents = inspectionEventsFromNative(res.data);
                this.setState({
                    inspectionEvents : inspectionEvents,
                    totalPage: res.totalPage,
                    totalElement: res.totalElement,
                    pageElement: res.pageElement,
                })
            }
        }, progressing, true);
    }

    refreshInspections = (ascending, sortir, progressing) => (
        this.setState({
            ascending:ascending,
            sortir:sortir,
        }, () => {
            this.fetchAll(ascending, sortir, this.state.search, progressing)
        })
    )




    render() {
        let {brandCategories, brandCategory, totalElement, totalPage} = this.state

        return (
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    style={{minWidth:'90%'}}
                    size="xl"
                    centered={true}
                    isOpen={this.props.showing}
                    backdrop={true}>
                    {super.render()}
                    <ModalCardHeader
                        content={(
                            <React.Fragment>
                                <h3 style={{display:'contents'}}>{label.History}</h3>
                                <div
                                    style={{float:"right", textAlign:'right'}}>
                                    <Button
                                        color="white"
                                        className="float-right btn-outline-black"
                                        onClick={() => {
                                            this.props.onClose()
                                        }}>{label.Close}</Button>
                                </div>
                            </React.Fragment>
                        )}/>
                    <ModalBody>
                        {this.renderInspectionEvent()}
                    </ModalBody>
                </Modal>

            </>
        )
    }

    renderInspectionEvent = () =>{
        let {ascending, sortir} = this.state
        let orderOptions = delegateObjectsForSelection(
            {name:label.SerialCode, field:'jie.serialCode'},
            {name:label.Performer, field:'jie.performerName'},
            {name:label.Created, field:'jie.created'},
            {name:label.Updated, field:'jie.updated'}
        )
        let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})

        return (
            <Row key={2}>
                <Col>
                    <Card>
                        <CardHeader>
                            <strong>{label.InspectionEvent}</strong>
                            <br/><br/>
                            <Row>
                                <Col>
                                    <ButtonGroup className="d-flex w-100">
                                        <DropdownInput
                                            title={label.SortBy}
                                            options={orderOptions}
                                            onSelect={(item) => {
                                                this.refreshInspections(ascending, item.field, true)
                                            }}
                                            onReset={() => {
                                                this.refreshInspections(ascending, "jie.created", true)
                                            }}/>
                                        &nbsp;&nbsp;&nbsp;
                                        <DropdownInput
                                            options={ascendingOptions}
                                            onSelect={(item) => {
                                                this.refreshInspections(item.field, sortir, true)
                                            }}
                                            onReset={() => {
                                                this.refreshInspections(true, sortir, true)
                                            }}/>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </CardHeader>
                        {this.renderInspectionEventTable()}
                    </Card>
                </Col>
            </Row>
        )
    }


    renderInspectionEventTable = () =>{
        return (
            <React.Fragment>
                <CardBody>
                    <Table responsive hover>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>{label.ReferenceCode}</th>
                            <th>{label.SerialCode}</th>
                            <th style={{width:'20%'}}>{label.Customer}</th>
                            <th>{label.Model}</th>
                            <th>{label.Performer}</th>
                            <th style={{width:'15%'}}>{label.Status}</th>
                            <th>{label.Created}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.inspectionEvents.map((item, index)=>(
                                <tr key={item.id}>
                                    <th scope="row">{((this.state.page-1)* this.state.pageElement)+(++index)}</th>
                                    <td><span>{item.inspection.reference}</span></td>
                                    <td><span>{item.serialCode}</span></td>
                                    <td>
                                        {label.OrderNo} : {item.customerOrderNo}<br/>
                                        {label.Client} : {item.client}<br/>
                                        {label.ProductSKU} : {item.productSKU}<br/>
                                        {label.ProductName} : {item.productName}<br/>
                                    </td>
                                    <td>
                                        {item.inspection.model.modelCategory.name}
                                        <br/>
                                        {item.inspection.model.systemType}
                                    </td>
                                    <td>
                                        <UserButton user={item.user}/>
                                    </td>
                                    <td>
                                        <StatusWidget status={item.inspectionStatus} statusColors={INSPECTION_STATUS_COLOR}/>
                                    </td>
                                    <td>{parseDate(item.created, DD_MM_YYYY_HH_MM_SS)}</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </Table>
                </CardBody>
                <ModalPagination {...this.props} currentPage={this.state.page} pageCount={this.state.totalPage} onSelect={(page)=>{
                    this.setState({
                        page:page
                    }, () => {
                        this.refreshInspections(this.state.ascending, this.state.sortir, true)
                    })
                }}/>
            </React.Fragment>
        )
    }


}

InspectionEventHistoryModal.propTypes = {
    showing:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    inspection:PropTypes.object.isRequired
}
